import { Input, Collapse, Button, Space } from "antd";
import React, { useState, Fragment, useContext } from "react";
import {
  ClearOutlined,
  CaretRightOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";
import SubmitBtn from "../../form-components/submit-btn";
import { debounce } from "lodash";
import { Controller, useForm } from "react-hook-form";
import RefreshBtn from "../table-components/actions/refresh-btn";
import AppContext from "../../../context/app/context";

const { Search } = Input;
const { Panel } = Collapse;

interface ISearchFilterCard {
  onReset: () => void;
  resetLoading: boolean;
  applyLoading?: boolean;
  formId?: string;
  visiableSearch?: boolean;
  searchValue: string | undefined;
  setSearchValue: (searchKey: any) => void;
  children?: React.ReactNode;
  paddingStyle?: boolean;
}
const SearchFilterCard: React.FC<ISearchFilterCard> = ({
  children,
  onReset,
  formId,
  resetLoading,
  searchValue,
  setSearchValue,
  visiableSearch,
  paddingStyle,
  applyLoading,
}) => {
  const { t } = useTranslation();
  const [showFilters, setShowFilters] = useState(false);
  const { control, reset } = useForm({ defaultValues: { keyword: "" } });
  const { screenSize } = useContext(AppContext);
  const [localSearchValue, setLocalSearchValue] = useState(searchValue || "");

  const debouncedUpdate = debounce((val) => {
    if (val) {
      setSearchValue(val);
    } else {
      setSearchValue(undefined);
    }
  }, 300);

  return (
    <div className={styles.filterCard}>
      <div
        style={{
          padding: paddingStyle ? "0" : "1rem",
          display: "flex",
          flexDirection: screenSize == "laptopOrDesktop" ? "row" : "column",
          gap:"10px",
          justifyContent: "space-between",
        }}
        className={React.Children.count(children) > 0 ? styles.cardHeader : ""}
      >
        {!visiableSearch && (
          <>
            <Controller
              name="keyword"
              control={control}
              render={({ field }) => (
                <Search
                  {...field}
                  placeholder={`${t("search_hint")}`}
                  style={{ width: screenSize == "laptopOrDesktop" ? "40%" : "100%" }}
                  enterButton
                  onSearch={(value) => {
                    setLocalSearchValue(value);
                    if (value) {
                      setSearchValue(value);
                    } else {
                      setSearchValue(undefined);
                    }
                  }}
                  onChange={(e) => {
                    const { value } = e.target;
                    setLocalSearchValue(value);
                    debouncedUpdate(value);
                    field.onChange(e);
                  }}
                  value={localSearchValue}
                  allowClear
                />
              )}
            />

            <Button
              danger
              type="default"
              loading={resetLoading}
              icon={<ClearOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                reset({ keyword: "" });
                setLocalSearchValue("");
                setSearchValue(undefined);
                onReset();
              }}
            >
              {t("reset")}
            </Button>
          </>
        )}
      </div>

      {children && (
        <Collapse
          bordered={true}
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          onChange={(key) => {
            setShowFilters(key?.includes("1"));
          }}
          style={{ marginTop: "15px" }}
          accordion
        >
          <Panel
            extra={
              <Fragment>
                {showFilters && (
                  <Space>
                    <SubmitBtn
                      icon={<FilterOutlined />}
                      loading={applyLoading}
                      onClick={(e) => e.stopPropagation()}
                      form={formId}
                    >
                      {t("apply")}
                    </SubmitBtn>
                  </Space>
                )}
              </Fragment>
            }
            header={t("filters")}
            key="1"
          >
            {children}
          </Panel>
        </Collapse>
      )}
    </div>
  );
};

export default SearchFilterCard;
